import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { parentalConsentCopy } from '@/Pages/ParentalConsent/copy';
import '@/Pages/ParentalConsent/ParentalConsentPage.sass';

type MinorContextBannerProps = {
  fullName: string;
};

export function MinorContextBanner({ fullName }: MinorContextBannerProps): JSX.Element {
  return (
    <Box
      className="parental-consent-minor-banner"
      data-testid="parental-consent-minor-banner"
      role="status"
    >
    <Box
      className="parental-consent-minor-banner__icon"
      data-testid="parental-consent-minor-icon"
      aria-hidden
    >
      <PersonOutlineRoundedIcon fontSize="large" />
    </Box>
      <Typography
        component="p"
        variant="body2"
        className="parental-consent-minor-banner__label"
      >
        {parentalConsentCopy.minorBannerLabel(fullName)}
      </Typography>
    </Box>
  );
}
